import React from 'react'

export default function NoPage() {
  return (
    <div style={{textAlign:'center'}}>404-NOTFOUND</div>
  )
}
